/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { ClientInformation } from "./data/types";
import { deleteOne } from "./data/clients";

const ClientDelete = ({
  selectedClient,
  open,
  onClose,
}: {
  selectedClient: ClientInformation;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          `Are you sure you want to delete the client "${selectedClient.name}"? This action cannot be undone.`,
          {
            title: "Confirm Client Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteOne(selectedClient.id);
            showNotification({
              message: "Client deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete client. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [open, confirm, selectedClient, showNotification, onClose]);

  return null;
};

export default ClientDelete;
